import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, signal, ViewChild } from '@angular/core';
import { BaseComponent } from '../../../../core/layout/components/abstracts/base.component';
import { SafePipe } from '../../../../shared/pipes/safe.pipe';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-tube-overlay-view',
  standalone: true,
  imports: [
    SafePipe
  ],
  templateUrl: './tube-overlay-view.component.html',
  styleUrl: './tube-overlay-view.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TubeOverlayViewComponent extends BaseComponent implements AfterViewInit {

  @ViewChild('tubeIframeEl') tubeIframeEl: ElementRef<HTMLIFrameElement>;

  public static instance: TubeOverlayViewComponent;
  public readonly isVisible = signal(false);
  public readonly environment = environment;

  public constructor() {
    super();
    TubeOverlayViewComponent.instance = this;
  }

  public ngAfterViewInit(): void {
    this.close();
  }

  public open(): void {
    this.isVisible.set(true);
    this.tubeIframeEl.nativeElement.contentWindow.postMessage({ type: 'startPlayer' }, '*');
  }

  public close(): void {
    this.isVisible.set(false);
    this.tubeIframeEl.nativeElement.contentWindow.postMessage({ type: 'stopPlayer' }, '*');
  }
}
